import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import {
  ConfigurationService,
  TimezoneService,
} from '@sc/data-access-configuration';
import { Fitter, GeoCoordinates } from '@sc/data-access-models';
import { DossierSandboxService } from '@sc/data-access-state-management';
import {
  FITTER_NAME_DISPLAY_CONTEXT,
  FitterNameDisplayContext,
  FitterNameDisplayService,
  FitterNamePipe,
} from '@sc/feature-contextual-display';
import { BaseGMapOverlay } from '../../../../utils/base-gmap-overlay';

@Component({
  selector: 'sc-gmap-fitter-card',
  styleUrls: ['./gmap-fitter-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    FitterNameDisplayService,
    {
      provide: FITTER_NAME_DISPLAY_CONTEXT,
      useValue: FitterNameDisplayContext.MapFitterCard,
    },
  ],
  imports: [NgClass, AsyncPipe, FitterNamePipe],
  template: `
    <div class="map-element">
      <div
        class="map-element-container"
        [ngClass]="{
          hover: fitterHover === fitter.id
        }"
        tabindex="0"
        role="button"
        (click)="onClick($event)"
        (keydown.enter)="onClick($event)"
        (keydown.space)="onClick($event)"
      >
        <div class="fitter-name-line sc-design-caption">
          <p>{{ fitter | fitterName | async }}</p>
        </div>
      </div>
    </div>
  `,
  host: {
    '[class]': 'fitter.brandId',
  },
})
export class GmapFitterCardComponent
  extends BaseGMapOverlay
  implements OnChanges, OnDestroy
{
  @Input() public map: google.maps.Map;
  @Input() public fitter: Fitter;
  @Input() public fitterHover: string;
  @Input() public set location(newLoc: GeoCoordinates) {
    this.position = newLoc;
  }

  @Output() public clickEvent = new EventEmitter<Fitter>();

  constructor(
    public timezoneService: TimezoneService,
    elRef: ElementRef,
    private readonly configService: ConfigurationService,
    public dossierSB: DossierSandboxService
  ) {
    super(elRef, 'gmap-fitter-card');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.map?.previousValue && !!changes.map?.currentValue) {
      this.gmap = changes.map.currentValue;
    }

    if (
      changes.fitterHover?.previousValue !== changes.fitterHover?.currentValue
    ) {
      this.updateClass(this.fitterHover === this.fitter.id ? 'hover' : '');
    }
  }

  ngOnDestroy(): void {
    this.onRemove();
  }

  hasCustomDotImage() {
    return !!this.configService.getConfig()?.map?.dotIcon;
  }

  onClick(clickEvent: Event) {
    this.clickEvent.emit(this.fitter);
    clickEvent.stopPropagation();
  }

  isFitterHaveNoSlot() {
    if (this.fitter) {
      return (
        this.configService.getFitterBrandInfosByBrandId(this.fitter.brandId)
          .booking.search.version == 'NO_SLOT'
      );
    }
  }
}
